import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { SourcesApi } from '../api';
import { Source } from '../types';

/**
 * Query keys for the source catalogue
 */
export const sourceKeys = {
  all: ['sources'] as const,
  list: () => [...sourceKeys.all, 'list'] as const,
};

/** The catalogue only changes on deploy. */
const SOURCES_STALE_TIME_MS = 30 * 60_000;

/**
 * Hook to get the source catalogue the user can connect
 */
export function useSources(
  sourcesApi: SourcesApi,
  options?: Omit<UseQueryOptions<Source[], Error>, 'queryKey' | 'queryFn'>
) {
  return useQuery<Source[], Error>({
    queryKey: sourceKeys.list(),
    queryFn: () => sourcesApi.getSources(),
    staleTime: SOURCES_STALE_TIME_MS,
    ...options,
  });
}
